'use client';

import { API_ROUTES, useApiQuery } from '@shared/api-utils';
import type { FreeBetNotificationData } from './types';

type UseFreeBetNotificationParams = {
  playerNr: string;
  enabled?: boolean;
};

function useFreeBetNotification({ playerNr, enabled = true }: UseFreeBetNotificationParams) {
  const url = API_ROUTES.SPORTSBOOK.FREE_BET.replace(':playerNr', playerNr);

  const { data, isLoading, error, refetch } = useApiQuery<FreeBetNotificationData>(url, {
    credentials: true,
    queryOptions: {
      enabled: enabled && !!playerNr,
    },
  });

  return {
    hasFreeBet: data?.hasFreeBet ?? false,
    status: data?.status ?? null,
    isLoading,
    error,
    refetch,
  };
}

export { useFreeBetNotification };
